var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expand-row"},[_c('Table',{attrs:{"border":"","stripe":"","columns":_vm.columns2,"data":_vm.row}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }